import { useState } from "react";
import BASE_URL from "../../config/apiConfig";

export default function CropMonitor() {
  const [ndviImg, setNdviImg] = useState(null);
  const [rviImg, setRviImg] = useState(null);
  const [avgNdvi, setAvgNdvi] = useState(null);
  const [avgRvi, setAvgRvi] = useState(null);

  const fetchCropData = async () => {
    const response = await fetch(`${BASE_URL}/api/user/crop-data/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        polygon: [
          [
            [89.02555988973167, 26.846287842999157],
            [89.02538822835471, 26.844296746366087],
            [89.02699755376365, 26.84333947590391],
            [89.02725504582908, 26.84527315389864],
            [89.02555988973167, 26.846287842999157],
          ],
        ],
        start_date: "2025-08-01",
        end_date: "2025-08-19",
      }),
    });

    const data = await response.json();
    setNdviImg(`data:image/png;base64,${data.ndvi_image}`);
    setRviImg(`data:image/png;base64,${data.rvi_image}`);
    setAvgNdvi(data.avg_ndvi);
    setAvgRvi(data.avg_rvi);
  };

  return (
    <div>
      <button onClick={fetchCropData}>Get Crop Data</button>
      {ndviImg && (
        <div>
          <h3>NDVI Map</h3>
          <img src={ndviImg} alt="NDVI" />
          <p>Average NDVI: {avgNdvi}</p>
        </div>
      )}
      {rviImg && (
        <div>
          <h3>RVI Map</h3>
          <img src={rviImg} alt="RVI" />
          <p>Average RVI: {avgRvi}</p>
        </div>
      )}
    </div>
  );
}
